import { useProjects } from '@/db/hooks'
import type { TaskResource } from '@/kinds/task/apply'
import { taskActions } from '@/lib/actions'
import { Button, Sheet } from './ui'

export const ProjectPicker = ({ task, open, onClose, current }: { task: TaskResource; open: boolean; onClose: () => void; current?: string }) => {
  const projects = (useProjects() ?? []).filter((p) => p.status.state === 'active' || p.status.state === 'paused')
  const pick = async (id: string | null) => {
    await taskActions.setProject(task, id)
    onClose()
  }
  return (
    <Sheet open={open} onClose={onClose} title="Project">
      <div className="flex flex-col gap-1">
        <Button big className="justify-start" variant={current ? 'ghost' : 'chipOn'} onClick={() => void pick(null)}>
          No project
        </Button>
        {projects
          .sort((a, b) => a.spec.title.localeCompare(b.spec.title))
          .map((p) => (
            <Button key={p.id} big className="justify-start" variant={current === p.id ? 'chipOn' : 'ghost'} onClick={() => void pick(p.id)}>
              {p.spec.title}
              {p.status.state === 'paused' && <span className="text-xs text-faint ml-1">paused</span>}
            </Button>
          ))}
        {!projects.length && <p className="text-sm text-faint py-3">No projects yet. Create one on the Projects page.</p>}
      </div>
    </Sheet>
  )
}
